<template>
    <div>
        <div id="canvas-container">
            <Gallery
                v-if="templates && templates.length > 0"
                titulo="Fotos Obrigatórias"
                uuid="requiredPhotos"
                :photos="photos"
                :templates="templates"
                :selectionMode="selectionMode"
                :isDelete="isDelete"
                @deleteEnd="deleteEnd"
                @takePhoto="takeFoto"
                :takenPhoto="newRequiredPhoto"
            />
            <Gallery
                v-if="additionalPhotos && additionalPhotos.length > 0"
                titulo="Fotos Adicionais"
                uuid="additionalPhotos"
                :photos="additionalPhotos"
                :selectionMode="selectionMode"
                :isDelete="isDelete"
                @deleteEnd="deleteEnd"
                @takePhoto="takeFoto"
                :takenPhoto="newAditionalPhoto"
            />
            <Gallery
                v-if="breakdownPhotos && breakdownPhotos.length > 0"
                titulo="Fotos de Avarias"
                uuid="breakdownPhotos"
                :photos="breakdownPhotos"
                :selectionMode="selectionMode"
                :isDelete="isDelete"
                @deleteEnd="deleteEnd"
                @takePhoto="takeFoto"
                :takenPhoto="newBreakdownPhoto"
            />
        </div>

        <div class="container-buttons">
            <b-button
                @click="setSelectionMode"
                class="ml-1 mt-3 buttons button"
                variant="warning"
            >
                <img width="22px" src="@/assets/imgs/check.png" alt="" />
            </b-button>

            <b-button
                v-if="!selectionMode"
                class="ml-1 mt-3 buttons button"
                variant="info"
                @click="takeFoto(null)"
            >
                <img width="22px" src="@/assets/imgs/plus.png" alt="" />
            </b-button>

            <b-button
                v-if="selectionMode"
                variant="danger"
                class="ml-1 mt-3 buttons button"
                @click="setIsDelete"
            >
                <img width="22px" src="@/assets/imgs/cross.png" alt="" />
            </b-button>
            <b-button class="mt-3 buttons button" variant="success" @click="nextPhase()">
                Próximo
            </b-button>
        </div>
    </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import Swal from "sweetalert2";
import Gallery from "@/components/inspection/photos/Gallery.vue";

export default {
    components: {
        Gallery,
        BButton
    },
    emits: [
        "nextPhase", "updateSelections"
    ],
    props: {
        takenPhoto: Object,
    },
    data: function () {
        return {
            selectionMode: false,
            isDelete: false,
            newAditionalPhoto: null,
            newBreakdownPhoto: null,
            newRequiredPhoto: null,
            photos: [],
            templates: [],
            additionalPhotos: [],
            breakdownPhotos: [],
            usaNomeFoto: null,
        };
    },
    methods: {
        getImagesData: function () {
            this.photos = this.$store.state.inspectionData.requiredPhotos;
            this.templates = this.$store.state.inspectionData.templates;
            this.breakdownPhotos = this.$store.state.inspectionData.breakdownPhotos;
            this.additionalPhotos = this.$store.state.inspectionData.additionalPhotos;
        },
        sendImagesToGallery: function (takenPhoto) {
            if (takenPhoto && takenPhoto.photoName.includes("ADICIONAL")) {
                this.newAditionalPhoto = takenPhoto;
            } else if (takenPhoto && takenPhoto.photoName.includes("AVARIA")) {
                this.newBreakdownPhoto = takenPhoto;
            } else {
                this.newRequiredPhoto = takenPhoto;
            }
        },
        setSelectionMode: function () {
            this.selectionMode = !this.selectionMode;
        },
        setIsDelete: function () {
            this.isDelete = !this.isDelete;
        },
        deleteEnd: function () {
            this.isDelete = false;
        },
        nextPhase: function () {
            this.$router.push("/inspection/inspector-signature");
        },
        takeFoto: function (photo) {
            if (photo) {
                this.$router.push({
                    name: "camera",
                    params: { photoData: photo }
                });
            } else {
                let aditionalPhoto = {};

                const photoOrder =
                    this.additionalPhotos.length === 0
                        ? 1
                        : this.additionalPhotos.length + 1;

                if (this.usaNomeFoto) {
                    Swal.fire({
                        title: "Inserir nome da imagem adicional",
                        input: "text",
                        showCancelButton: true,
                        cancelButtonText: "Cancelar",
                        confirmButtonText: "Ok",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            aditionalPhoto = {
                                ordem: photoOrder,
                                photoName:
                                    result.value && result.value.length > 0
                                        ? `ADICIONAL_${photoOrder}_${result.value}`
                                        : `ADICIONAL_${photoOrder}`,
                            };
                            this.$router.push({
                                name: "camera",
                                params: { photoData: aditionalPhoto }
                            });
                        }
                    });
                } else {
                    aditionalPhoto = {
                        ordem: photoOrder,
                        photoName: `ADICIONAL_${photoOrder}`,
                    };
                    this.$router.push({
                        name: "camera",
                        params: { photoData: aditionalPhoto }
                    });
                }
            }
        },
    },
    mounted: function () {
        const operationParams = this.$store.state.inspectionData.operation.parametros;
        this.usaNomeFoto = operationParams?.abrir_dialog_inserir_texto.ativo ?? false;

        this.getImagesData();

        if (this.takenPhoto) {
            if (
                this.additionalPhotos &&
                this.additionalPhotos.length === 0 &&
                this.takenPhoto.photoName.includes("ADICIONAL")
            ) {
                this.additionalPhotos.push(this.takenPhoto);
            } else if (
                this.breakdownPhotos &&
                this.breakdownPhotos.length === 0 &&
                this.takenPhoto.photoName.includes("AVARIA")
            ) {
                this.breakdownPhotos.push(this.takenPhoto);
            }
            this.sendImagesToGallery(this.takenPhoto);
        }
    },
};
</script>

<style scoped>
.container-buttons {
    background: linear-gradient(#cdd7d6, white);
    width: 100%;
    position: fixed;
    bottom: 0;
    padding-left: 7%;
    padding-right: 7%;
    padding-bottom: 10px;
    right: 0;
    display: flex;
    justify-content: space-between;
}

.buttons {
    float: right;
    width: 100px;
    margin-right: 0;
}
</style>
